import { ICarSearchData } from 'models/car/ICarSearchData';
import { Location } from 'models/others/ISearchLocationRS';
import { ISearchLocationFlight } from 'pages/select-destination/search-passagem-aerea/SearchAirports';
import { ISearchLocationPackageRS } from '../models/others/ISearchLocationRS';

export interface IContext {
  isUserLogged: boolean;
  isProfileChanged: boolean;
  isProfilePhotoChanged: null;
  showModal: boolean;
  showWelcome: boolean;
  modalContent: string;
  modalTitle: string;
  loadingGlobal: {
    isLoading: boolean;
    textLoading: string;
  };
  packagePlan: {
    isPackage: boolean;
    flight: any;
    hotel: any;
  };
  flight: {
    tarifarRq: any;
    dataVooSelecionado: any;
    dadosConsultaVoos: any;
    dataFlightSearch: ISearchLocationFlight;
  };
  flightCardSelected: {
    id: any;
  };
  hotel: {
    allSelected: boolean;
    citySelected: Location;
  };
  package: {
    dataSearchPackageSelected: ISearchLocationPackageRS;
  };
  loadingSplash: boolean;
  toast: {
    level: boolean;
    visible: boolean;
    message: string;
  };
  error: {
    statusCode: number;
    statusText: string;
  };
  showAboutUs: boolean;
  cartPlan: {
    showCartPlan: boolean;
    showCartList: boolean;
    hotelSelected: any;
    aereoSelected: any;
    step: any;
  };
  selectDestination: string;
  car: {
    dataSearchCar: ICarSearchData;
  };
  dispatch?: IDispatch;
}

export type IDispatch = (action: any) => void;

export const initialState: IContext = {
  isUserLogged: false,
  isProfileChanged: false,
  isProfilePhotoChanged: null,
  showModal: false,
  showWelcome: false,
  modalContent: null,
  modalTitle: null,
  loadingGlobal: {
    isLoading: false,
    textLoading: null,
  },
  packagePlan: {
    isPackage: false,
    flight: null,
    hotel: null,
  },
  flight: {
    tarifarRq: null,
    dataVooSelecionado: null,
    dadosConsultaVoos: null,
    dataFlightSearch: null,
  },
  flightCardSelected: {
    id: null,
  },
  hotel: {
    allSelected: false,
    citySelected: null,
  },
  package: {
    dataSearchPackageSelected: null,
  },
  loadingSplash: false,
  toast: {
    level: false,
    visible: false,
    message: null,
  },
  error: {
    statusCode: null,
    statusText: null,
  },
  showAboutUs: false,
  cartPlan: {
    showCartPlan: false,
    showCartList: false,
    hotelSelected: undefined,
    aereoSelected: undefined,
    step: null,
  },
  selectDestination: 'pacote',
  car: {
    dataSearchCar: null,
  },
};

export const reducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case 'LOGIN_CHANGED':
      return {
        ...state,
        isUserLogged: action.isUserLogged,
      };
    case 'PROFILE_CHANGED':
      return {
        ...state,
        isProfileChanged: action.isProfileChanged,
      };
    case 'PROFILE_PHOTO_CHANGED':
      return {
        ...state,
        isProfilePhotoChanged: action.isProfilePhotoChanged,
      };
    case 'SHOW_MODAL':
      return {
        ...state,
        showModal: action.showModal,
        modalContent: action.modalContent,
        modalTitle: action.modalTitle,
      };
    case 'SHOW_WELCOME':
      return {
        ...state,
        showWelcome: action.showWelcome,
      };
    case 'LOADING':
      return {
        ...state,
        loadingGlobal: {
          isLoading: action.isLoading,
          textLoading: action.textLoading || null,
        },
      };
    case 'LOADING_SPLASH':
      return {
        ...state,
        loadingSplash: action.loadingSplash,
      };
    case 'UPDATE_PACKAGE':
      return {
        ...state,
        packagePlan: action.packagePlan,
      };
    case 'UPDATE_PACKAGE_FLIGHT':
      return {
        ...state,
        packagePlan: {
          ...state.packagePlan,
          flight: action.flight,
          isPackage: action.isPackage || false,
        },
      };
    case 'UPDATE_TARIFAR_RQ':
      return {
        ...state,
        flight: {
          ...state.flight,
          tarifarRq: action.tarifarRq,
          dataVooSelecionado: action.dataVooSelecionado,
          dadosConsultaVoos: action.dadosConsultaVoos,
        },
      };
    case 'UPDATE_HOTEL_QTD':
      return {
        ...state,
        hotel: {
          ...state.hotel,
          isAllApSelected: action.isAllApSelected || false,
          Apartments: action.hotel || null,
          dadosPlanoHotel: action.dadosPlanoHotel || null,
        },
      };
    case 'UPDATE_PACKAGE_HOTEL':
      return {
        ...state,
        packagePlan: {
          ...state.packagePlan,
          hotel: action.hotel,
          isPackage: action.isPackage || false,
        },
      };
    case 'EMPTY_PACKAGE':
      return {
        ...state,
        packagePlan: {
          isPackage: false,
          flight: null,
          hotel: null,
        },
        flight: {
          tarifarRq: null,
          dataVooSelecionado: null,
          dadosConsultaVoos: null,
        },
        hotel: {
          allSelected: false,
        },
      };
    case 'ERROR_401':
      return {
        ...state,
        error: {
          statusCode: action.statusCode,
          statusText: action.statusText,
        },
      };
    case 'UPDATE_FLIGHT_SELECTED':
      return {
        ...state,
        flightCardSelected: {
          id: action.id,
        },
      };
    case 'UPDATE_ABOUT_US':
      return {
        ...state,
        showAboutUs: action.showAboutUs,
      };
    case 'SHOW_CART_PLAN':
      return {
        ...state,
        cartPlan: {
          ...state.cartPlan,
          showCartPlan: action.showCartPlan,
        },
      };
    case 'SHOW_CART_LIST':
      return {
        ...state,
        cartPlan: {
          ...state.cartPlan,
          showCartList: action.showCartList,
        },
      };
    case 'ADD_HOTEL_TRAVEL_PLAN':
      return {
        ...state,
        cartPlan: {
          ...state.cartPlan,
          step: action.step,
          hotelSelected: action.hotelSelected,
        },
      };
    case 'ADD_FLIGHT_TRAVEL_PLAN':
      return {
        ...state,
        cartPlan: {
          ...state.cartPlan,
          step: action.step,
          aereoSelected: action.aereoSelected,
        },
      };

    case 'EMPTY_ALL':
      return {
        ...initialState,
      };
    case 'SELECT_DESTINATION':
      return {
        ...state,
        selectDestination: action.selectDestination,
      };

    case 'UPDATE_HOTEL_CITY_SELECTED':
      return {
        ...state,
        hotel: {
          ...state.hotel,
          citySelected: action.citySelected,
        },
      };

    case 'UPDATE_PACKAGE_CITY_SELECTED':
      return {
        ...state,
        package: {
          dataSearchPackageSelected: action.dataSearchPackageSelected,
        },
      };

    case 'UPDATE_CAR_CITY_SELECTED':
      return {
        ...state,
        car: {
          dataSearchCar: action.dataSearchCar,
        },
      };

    case 'UPDATE_FLIGHT_CITY_SELECTED':
      return {
        ...state,
        flight: {
          ...state.flight,
          dataFlightSearch: action.dataFlightSearch,
        },
      };

    default:
      return { ...state };
  }
};
